import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { MagazinePage } from '../magazine/magazine';
/**
 * Generated class for the MagazineLandingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-magazine-landing',
  templateUrl: 'magazine-landing.html',
})
export class MagazineLandingPage {

  cat_id: any;
  boxes: any;
  title: string;

  constructor(public events: Events, public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    this.cat_id = this.navParams.get("cat_id");
    this.title = this.navParams.get("title");

    this.loadCat();
  }

  loadCat() {
    console.log('cat_id='+this.cat_id);
    this.teamappProvider.http_request('cat_id='+this.cat_id+'&require_type=1', 'cms', false, true).then(data => {

        let boxData: any = data;
        if(!boxData.error) {
            this.boxes = boxData;
        }
        console.log(this.boxes);
    });
  }

  openMagazine(type, target, id: number, title: string) {
    if(type=='cms' || type=='') {
        this.navCtrl.push(MagazinePage,{page: id, title: title});
    }

    if(type=='module') {
        this.events.publish('app:changepage',target, title, null);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MagazineLandingPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/magazine-landing/magazine-landing.ts